import Generic, { autotab, ariaLabel, closest } from './Generic';

export default Generic;
export { autotab, ariaLabel, closest };
